(() => {
  const CM_PER_INCH = 2.54;

  function isLikelyNumericCell(text) {
    if (!text) return false;
    const t = text.trim();
    if (!t) return false;
    // Avoid size ranges like "40/42" or mixed strings.
    if (t.includes("/") || /[a-zA-Z]/.test(t)) return false;
    // Allow numbers with dot/comma decimal.
    return /^-?\d+(?:[.,]\d+)?$/.test(t);
  }

  function parseNumber(text) {
    const t = text.trim().replace(",", ".");
    const n = Number(t);
    return Number.isFinite(n) ? n : null;
  }

  function formatInches(n) {
    return n.toFixed(2);
  }

  function prepareTable(root) {
    const tables = root.querySelectorAll(".rte table");
    tables.forEach((table) => {
      if (table.closest(".product__size-info-equivalence")) return;

      const rows = table.querySelectorAll("tr");
      for (const row of rows) {
        const cells = row.querySelectorAll("td, th");

        cells.forEach((cell) => {
          const raw = (cell.textContent || "").trim();
          if (!isLikelyNumericCell(raw)) return;
          const cm = parseNumber(raw);
          if (cm === null) return;

          cell.dataset.sizeUnitCm = String(cm);
          const inches = cm / CM_PER_INCH;
          cell.dataset.sizeUnitIn = formatInches(inches);
          cell.dataset.sizeUnitPrepared = "true";
        });
      }
    });
  }

  function setUnit(root, unit) {
    root.dataset.sizeUnit = unit;
    const prepared = root.querySelectorAll('[data-size-unit-prepared="true"]');
    prepared.forEach((cell) => {
      if (unit === "in") {
        cell.textContent = cell.dataset.sizeUnitIn || cell.textContent;
      } else {
        const cm = cell.dataset.sizeUnitCm;
        if (cm != null) cell.textContent = cm;
      }
    });

    root.querySelectorAll("[data-size-unit-switch]").forEach((btn) => {
      const isActive = btn.getAttribute("data-size-unit-switch") === unit;
      btn.setAttribute("aria-pressed", isActive ? "true" : "false");
    });

    const toggle = root.querySelector("[data-size-unit-toggle]");
    if (toggle) {
      toggle.checked = unit === "in";
    }
  }

  function initDrawer(drawerRoot) {
    if (!drawerRoot || drawerRoot.dataset.sizeUnitInited === "true") return;
    drawerRoot.dataset.sizeUnitInited = "true";
    prepareTable(drawerRoot);
    setUnit(drawerRoot, "cm");
  }

  // Initialize any drawers already in DOM.
  document.querySelectorAll(".product__size-info").forEach(initDrawer);

  // Re-init on theme editor changes.
  document.addEventListener("shopify:section:load", () => {
    document.querySelectorAll(".product__size-info").forEach(initDrawer);
  });

  // Handle unit switch clicks (event delegation).
  document.addEventListener("click", (e) => {
    const btn = e.target.closest("[data-size-unit-switch]");
    if (!btn) return;
    const drawerRoot = btn.closest(".product__size-info");
    if (!drawerRoot) return;
    const unit = btn.getAttribute("data-size-unit-switch");
    if (unit !== "cm" && unit !== "in") return;
    initDrawer(drawerRoot);
    setUnit(drawerRoot, unit);
  });

  // Handle toggle change.
  document.addEventListener("change", (e) => {
    const toggle = e.target && e.target.matches && e.target.matches("[data-size-unit-toggle]")
      ? e.target
      : null;
    if (!toggle) return;
    const drawerRoot = toggle.closest(".product__size-info");
    if (!drawerRoot) return;
    initDrawer(drawerRoot);
    setUnit(drawerRoot, toggle.checked ? "in" : "cm");
  });
})();

